module.exports = __webpack_public_path__ + "img/capenormandy_053022KV.71bfe571.jpg";